export function asString(value) {
  return typeof value === "string" ? value.trim() : "";
}
